<template>
  <ul class="failure-list list-unstyled mb-0">
    <li v-for="entry in entries" :key="entry.key" class="failure-list-item">
      <failure-icon :type="entry.presentation.type" :text="entry.text" class="failure-list-icon"></failure-icon>
      <div class="failure-list-body">
        <div v-if="entry.certificate" class="failure-list-certificate">
          <strong>{{ entry.certificate }}</strong>
          <span v-if="entry.productName" class="text-muted ml-2">{{ entry.productName }}</span>
        </div>
        <div class="failure-list-text">{{ entry.text }}</div>
      </div>
    </li>
  </ul>
</template>

<script>
// The reasons of the last execution of a test, one entry per cause: the icon of its kind, the certificate
// and the words. What needs a change comes first, because "Execute again" does not fix it. Read-only. The
// reference of a failure (`id`) is never shown: it stays in the API and the logs for the support.
import FailureIcon from './FailureIcon.vue'
import { failurePresentation, FAILURE_TYPES } from '../../utils/failurePresentation'

export default {
  components: { FailureIcon },

  props: {
    // `failures[]` of the test.
    failures: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    entries() {
      const entries = this.failures.map((failure, index) => {
        const presentation = failurePresentation(failure)
        return {
          key: index,
          presentation,
          text: this.$t(presentation.textKey, presentation.textParams),
          certificate: failure.isin || null,
          productName: failure.productName || null,
        }
      })

      // Stable: what needs a change first, the order of the server within each group.
      const rank = (entry) => (entry.presentation.type === FAILURE_TYPES.BLOCKING ? 0 : 1)
      return entries.sort((a, b) => rank(a) - rank(b) || a.key - b.key)
    },
  },
}
</script>

<style lang="scss" scoped>
.failure-list-item {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}
.failure-list-item:last-child {
  border-bottom: 0;
}
.failure-list-icon {
  flex: 0 0 auto;
  margin: 0.25rem 0.75rem 0 0;
}
.failure-list-body {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
